<template>
  <div class="__dropdown-submenu">
    <input
      :id="inputId"
      v-model="radioButtonSelected"
      type="radio"
      :name="inputName"
      :value="inputId"
    >
    <label
      for="id"
      @click="changeMenu(inputId)"
    >
      <span class="__dropdown-submenu-label">{{ text }}</span>
      <i
        v-if="selectedFilter"
        class="chart-dot-blue"
      />
      <GjIcon
        name="ArrowRight"
      />
    </label>

    <ul
      v-if="radioButtonSelected === inputId"
      class="__dropdown-submenu-level"
      :class="containsImages ? '__dropdown-submenu-level-with-image' : ''"
    >
      <slot name="header" />
      <div :class="submenus ? '' : '__dropdown-submenu-level-overflow'">
        <slot name="items" />
      </div>
      <slot name="footer" />
    </ul>
  </div>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'

export default {
  components: {
    GjIcon,
  },
  props: {
    text: {
      type: String,
      default: '',
    },
    inputId: {
      type: String,
      default: '',
    },
    inputName: {
      type: String,
      default: '',
    },
    checked: {
      type: String,
      default: '',
    },
    submenus: {
      type: Boolean,
      default: false,
    },
    selectedFilter: {
      type: Boolean,
      default: false,
    },
    containsImages: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    radioButtonSelected() {
      return this.checked
    },
  },
  methods: {
    changeMenu(selectedMenu) {
      this.$emit('changeSelectedMenu', selectedMenu)
    },
  },
}
</script>

<style lang="scss">
.__dropdown-submenu-level, .__dropdown-submenu ul, div.__dropdown-submenu input[type="radio"] {
    display: none;
}

.__dropdown-submenu input[type="radio"]:checked + label{
    color: #1d79f2 !important;
    background-color: #fff;
}
div.__dropdown-submenu-level {
  background-color: #ffffff;
  border-radius: 0.358rem;
  padding: 8px;
  width: 220px;
  margin: 0;
  font-weight: 400;
  transition: all 0.3s;
  border: 1px solid rgba(44, 44, 44, 0.05);
  background-clip: padding-box;
}

div.__dropdown-submenu{
  width: 100%;
  height: 34px;
  line-height: 34px;
  color: #667c99 !important;

  label {
    color: #667c99 !important;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    margin: 0;
    color: #667c99 !important;
    padding: 0px 4px 0px 12px;
    border-radius: 0.358rem;
    &:hover {
    color: #1d79f2 !important;
    background-color: #fafafa;
    }
  }
}

div.__dropdown-submenu ul.__dropdown-submenu-level {
  position:relative;
  top: -34px;
  list-style: none;
  right: calc(100% + 35px);
  background-color: #ffffff;
  border-radius: 0.358rem;
  padding: 8px;
  width: 230px;
  margin: 0;
  font-weight: 400;
  transition: all 0.3s;
  border: 1px solid rgba(44, 44, 44, 0.05);
  background-clip: padding-box;
  box-shadow: -2px 2px 67px -40px rgba(0,0,0,0.75);
  div.__dropdown-submenu-level-overflow{
    max-height: 340px;
    overflow-y:auto;
  }
  &.__dropdown-submenu-level-with-image{
    right: calc(100% + 45px);
    width: 250px;
  }
}

span.__dropdown-submenu-label{
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.__dropdown-submenu{
  i.chart-dot-blue{
    width: 7px;
    height: 6px;
    margin-bottom: 0px;
  }
}
</style>
